import _ from "lodash";

export const getCustomFieldsDefaultValues = customFields => {
  if (!customFields || _.isEmpty(customFields)) {
    return {};
  }

  const defaultValues = {};

  customFields.forEach(customField => {
    const key = customField.name;
    defaultValues[key] = customField.options[0];
  });

  return defaultValues;
};

export const extendFormDataWithSelectValues = (questionData, customFields) => {
  const questionDataWithSelectValues = _.cloneDeep(questionData);

  const subjectAreaKey = "subjectArea";
  if (questionData.hasOwnProperty(subjectAreaKey)) {
    // Handle value from react-select
    questionDataWithSelectValues[subjectAreaKey] = questionData[subjectAreaKey].value;
  }

  const questionKey = "question";
  // Question can be a simple text field or a react-select component
  if (_.isObject(questionData[questionKey])) {
    questionDataWithSelectValues[questionKey] = questionData[questionKey].value;

    const docId = questionData[questionKey].docId;
    if (docId) {
      // Save doc ID in case we want to update an existing FAQ
      questionDataWithSelectValues.docId = docId;
    }
  }

  if (!customFields) {
    return questionDataWithSelectValues;
  }

  questionDataWithSelectValues.customFields = {};

  // Add custom fields (which are rendered via selects) under the customFields key.
  customFields.forEach(customField => {
    const formKey = customField.name;
    const targetKey = customField.sourceFieldName;

    if (questionData.hasOwnProperty(formKey)) {
      delete questionDataWithSelectValues[formKey];
      questionDataWithSelectValues.customFields[targetKey] = questionData[formKey].value;
    }
  });

  return questionDataWithSelectValues;
};
